export interface TimelineEvent {
  img: string;
  name: string;
  year: string;
  description: string;
  qr: string;
}

export const EVENTS: TimelineEvent[] = [
  {
    year: "Pre-1769",
    description:
      "The land upon which Dartmouth College now sits is the ancestral home of the Abenaki people. It consisted of unspoiled green forests and the sparkling waters of the Kwanitekw, which means “Long River” and the Wôbatekw, meaning “Clear River.” The land Dartmouth was built upon remains the unceded home to the Abenaki people.",
    img: "https://vermonthistoryexplorer.org/client_media/assets/crops/default.e96b7ba8.abenakimontreal.jpg",
    name: "Abenaki People",
    qr: "https://students.dartmouth.edu/nap/about/history",
  },
  {
    year: "1769",
    description:
      "Dartmouth College is founded by Eleazar Wheelock. In the beginning, the school consisted of just two log cabins. Over the next few decades, more buildings are built and heated with coal.",
    img: "https://upload.wikimedia.org/wikipedia/commons/a/a2/Early_Dartmouth_Dunham.jpg",
    name: "Dartmouth College Founded",
    qr: "https://en.wikipedia.org/wiki/Dartmouth_College#/media/File:Early_Dartmouth_Dunham.jpg",
  },
  {
    year: "1853",
    description:
      "The first scientific examination of crude oil, which led to the beginning of the world’s petroleum industry was conducted in Crosby Hall on the Dartmouth campus.",
    img: "https://tile.loc.gov/storage-services/service/pnp/det/4a00000/4a08000/4a08300/4a08319v.jpg#h=803&w=1024",
    name: "Crosby Hall",
    qr: "https://www.dartmo.com/views/westside/crosby2.html",
  },
  {
    year: "1898",
    description:
      "The Dartmouth Heating Plant, a cogeneration plant, producing both electricity and heat by sending low-pressure steam around campus using coal as a fuel source, opens on the now 10-building large campus.",
    img: "/timelineImg/1898_Heating.png",
    name: "Construction on the Dartmouth Heating Plant",
    qr: "https://www.youtube.com/watch?v=RynFstF18dg&t=655s&ab_channel=AugustFilm2013",
  },
  {
    year: "1958",
    description:
      "Dartmouth switches from using coal to heat buildings to Number 6 fuel oil. Number 6 is used because it is cheaper than other fuel oils and has an extremely high-energy concentration. The heating plant at Dartmouth still uses up to 200,000 gallons of Number 6 oil a week!",
    img: "/timelineImg/1958_No6.png",
    name: "Switches from Coal to Number 6",
    qr: "https://www.youtube.com/watch?v=ELppXcYAM10&ab_channel=DART.ENVS.01.X",
  },
  {
    year: "1995",
    description:
      "The first photovoltaic system is installed on the Dartmouth campus on the roof of Murdough Hall. It cost $60,000 and produces up to 20 kilowatt hours of energy per day on a nice day.",
    img: "/timelineImg/1995_Panels.png",
    name: "The First Photovoltaic System is Installed",
    qr: "https://www.thedartmouth.com/article/1995/11/panels-to-be-installed",
  },
  {
    year: "2006",
    description:
      "The McLaughlin Cluster, Fahey-McLane Residence Halls and Kemeny-Haldeman are the first buildings on the Dartmouth campus to achieve a LEED certification (gold and silver). Since then, six more buildings have achieved LEEDs certifications.",
    img: "/timelineImg/2006_LEED.png",
    name: "Achieved a LEED Certification",
    qr: "https://www.dartmouth.edu/fom/sustainability/high_performance_buildings/index.php",
  },
  {
    year: "2010",
    description:
      "The Dartmouth Sustainability Office is founded. It is directed by Rosi Kerr (D’97).",
    img: "/timelineImg/2010_Rosi.png",
    name: "Dartmouth Sustainability Office Founded",
    qr: "https://www.sustainability.dartmouth.edu/",
  },
  {
    year: "2016",
    description: "Dartmouth develops and publishes a High Performance Building Energy Policy for major capital building projects.",
    img: "https://campus-services.dartmouth.edu/sites/campus_services.prod/files/campus_services/images/20210713_aerial_eb_040.jpg",
    name: "High Performance Building Energy Policy",
    qr: "https://www.dartmouth.edu/fom/docs/high_perf_bldg_energy_policy.pdf",
  },
  {
    year: "2017",
    description: "President Phil Hanlon makes an Earth Day pledge to transition Dartmouth to a low-carbon future by reducing greenhouse gas emissions from 2010 levels by 80% by 2050, transitioning to renewable sources of energy by 2025 and creating a better distribution system across campus.",
    img: "https://home.dartmouth.edu/sites/home/files/styles/max_width_2880px/public/news/images/earth-day-810.jpg?itok=f77EX60k",
    name: "Transition to Low-Carbon Future",
    qr: "https://home.dartmouth.edu/news/2017/04/president-hanlon-big-green-will-go-more-green",
  },
  {
    year: "2020",
    description: "Dartmouth abandons plans to create a biomass plant and begins to explore geothermal.",
    img: "https://marvel-b1-cdn.bc0a.com/f00000000283318/admissions.dartmouth.edu/sites/admissions.prod/files/styles/400x274_blog/public/admissions/content/blog-post/photos/img_4772.jpg?itok=xSYCn6LD&timestamp=1706991913",
    name: "Geothermal Energy",
    qr: "https://home.dartmouth.edu/news/2019/01/new-biomass-plant-will-increase-dartmouths-sustainability",
  },
  {
    year: "2021",
    description: "Dartmouth commits to divesting its stock portfolio from fossil fuels.",
    img: "https://snworksceo.imgix.net/drt/df675149-f79e-4955-963a-3fd1a3c8a46d.sized-1000x1000.jpg?w=1000&dpr=2",
    name: "Divestment",
    qr: "https://home.dartmouth.edu/news/2021/10/dartmouth-taking-comprehensive-steps-address-climate-crisis",
  },
  {
    year: "2022",
    description: "The Irving Institute building opens with a mission to “advance an affordable, sustainable, and reliable energy future for the benefit of society.”",
    img: "https://irving.dartmouth.edu/sites/irving_energy.prod/files/irving_energy/images/building-lights.png",
    name: "Irving Institue Opens",
    qr: "https://irving.dartmouth.edu/news/2022/03/welcome-institutes-new-home",
  },
  {
    year: "2022",
    description: "President Hanlon announces Our Green Future 2.0, which included $50 million in upgrades to infrastructure, including converting steam tunnels to hot water heating and cooling.",
    img: "/timelineImg/2022_Future.png",
    name: "Green Future 2.0",
    qr: "https://www.sustainability.dartmouth.edu/ogf-update",
  },
];

